import { forwardRef, RefObject } from 'react';
import { styled } from 'styled-components';

import { isLink } from '@numa-group/ui.button-or-link';

import Chevron from '@src/components/atoms/action/chevron';

import { ButtonWrapper, Content, Heading, ImageWrapper, InnerWrapper, LinkWrapper, Text } from './styles';
import { PreviewListItemProps } from './types';

const PreviewListItem = forwardRef<HTMLButtonElement | HTMLAnchorElement, PreviewListItemProps>(
  ({ image, heading, text, isQuiet, footer, ...props }, ref) => {
    const children = (
      <>
        <InnerWrapper>
          <ImageWrapper>{image}</ImageWrapper>

          <Content>
            <Heading>{heading}</Heading>
            {text && <Text>{text}</Text>}
          </Content>

          <Chevron />
        </InnerWrapper>

        {footer}
      </>
    );

    if (isLink(props)) {
      return (
        <LinkWrapper ref={ref as RefObject<HTMLAnchorElement>} {...props} $isQuiet={isQuiet}>
          {children}
        </LinkWrapper>
      );
    }

    return (
      <ButtonWrapper ref={ref as RefObject<HTMLButtonElement>} {...props} $isQuiet={isQuiet}>
        {children}
      </ButtonWrapper>
    );
  },
);
PreviewListItem.displayName = 'PreviewListItem';
export default styled(PreviewListItem)``;
